import transverser from '@/helpers/transverser'
import store from '@/store'

export default (to, from, next) => {
  let needMeRoute = transverser.get('meta.needMe', false)(to)
  if (!needMeRoute) return next()
  store.dispatch('me/get')
  .then(() => {
    return next()
  }, err => {
    console.error(err)
    // Avoid navigate to error component, this will launch an error on the banner in the current view
    // return next({
    //   name: 'err'
    // })
  })
}
